export default __webpack_public_path__ + "a5d5bbe830f5e19fc5993b46c59161cb.png";